import { fromJS, Map } from 'immutable';

export function request(state, { id }) {
    let comment = state.get('comment') || Map();

    comment = comment.set(id, Map({
        state: 'IN_PROGRESS',
        status
    }));

    return state.set('comment', comment);
}

export function error(state, { id, errors }) {
    let comment = state.get('comment') || Map();

    comment = comment.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('comment', comment);
}

export function finish(state, { id, data }) {
    let comment = state.get('comment') || Map();

    comment = comment.set(id, Map({
        state: 'FINISHED'
    }));

    let items = state.get('items') || Map();
    items = items.set(id, (items.get(id) || Map()).merge(fromJS(data)));

    return state
        .set('items', items)
        .set('comment', comment);
}
